var AppService = (function () {
    function AppService() {
    }
    AppService.prototype.getCurrentUser = function () {
        return JSON.parse(sessionStorage.getItem('currentUser'));
    };
    AppService.prototype.getJwt = function () {
        return JSON.parse(sessionStorage.getItem('jwt'));
    };
    return AppService;
}());
export { AppService };



// WEBPACK FOOTER //
// /build/client-cms/src/app/app.service.ts.pre-build-optimizer.js